<template>
  <div class="filter-mobile">
    <div
      class="filter-mobile__label display-flex-center justify-content-between"
      :class="{ 'layout-2': !bookGroups || bookGroups.length === 0 }"
    >
      <div
        class="
          item
          btn btn-gray
          border-rd-20
          display-flex-center
          justify-content-center
        "
        :class="{ active: selectBoxOpen === 'class' }"
        @click="handleCollapseSelect('class')"
      >
        <span
          class="item__name font-sanpro-semibold font-size-16"
          :class="{
            'primary-color': selectBoxOpen === 'class',
            'secondary-color-txt': selectBoxOpen !== 'class',
          }"
        >
          {{ classes[classIndexActive].name }}
        </span>
        <span class="item__icon">
          <i
            class="icon-arrow-down font-size-12"
            :class="{
              'primary-color': selectBoxOpen === 'class',
              'secondary-color-txt': selectBoxOpen !== 'class',
            }"
          ></i>
        </span>
      </div>
      <div
        v-if="bookGroups && bookGroups.length > 0"
        class="
          item
          btn btn-gray
          border-rd-20
          display-flex-center
          justify-content-center
        "
        :class="{ active: selectBoxOpen === 'group' }"
        @click="handleCollapseSelect('group')"
      >
        <span
          class="item__name font-sanpro-semibold font-size-16"
          :class="{
            'primary-color': selectBoxOpen === 'group',
            'secondary-color-txt': selectBoxOpen !== 'group',
          }"
        >
          Bộ sách
        </span>
        <span class="item__icon">
          <i
            class="icon-arrow-down font-size-12"
            :class="{
              'primary-color': selectBoxOpen === 'group',
              'secondary-color-txt': selectBoxOpen !== 'group',
            }"
          ></i>
        </span>
      </div>
      <div
        class="
          item
          btn btn-gray
          border-rd-20
          display-flex-center
          justify-content-center
        "
        :class="{ active: selectBoxOpen === 'type' }"
        @click="handleCollapseSelect('type')"
      >
        <span
          class="item__name font-sanpro-semibold font-size-16"
          :class="{
            'primary-color': selectBoxOpen === 'type',
            'secondary-color-txt': selectBoxOpen !== 'type',
          }"
        >
          Loại sách
        </span>
        <span class="item__icon">
          <i
            class="icon-arrow-down font-size-12"
            :class="{
              'primary-color': selectBoxOpen === 'type',
              'secondary-color-txt': selectBoxOpen !== 'type',
            }"
          ></i>
        </span>
      </div>
    </div>
    <div class="filter-mobile__body">
      <div
        v-if="selectBoxOpen === 'class'"
        class="filter-mobile__class display-flex-wrap justify-content-between"
      >
        <a
          v-for="(item, index) of classes"
          :key="index"
          href="javascript:;"
          class="
            item
            btn btn-gray
            border-rd-20
            font-sanpro-semibold font-size-15
          "
          :class="{
            'active primary-color': selectClass === item.classId,
            'secondary-color-txt': selectClass !== item.classId,
            'w-auto': item.classNo === 0,
          }"
          @click="handleFilterByClass(item)"
          style="margin-right: 0px"
        >
          {{ item.classNo === 0 ? "Mầm non" : item.classNo }}
        </a>
      </div>
      <div
        v-else-if="selectBoxOpen === 'group'"
        class="filter-mobile__group display-flex-wrap justify-content-between"
      >
        <a
          v-for="(item, index) of bookGroups"
          :key="index"
          href="javascript:;"
          class="
            item
            btn btn-gray
            border-rd-20
            font-sanpro-semibold font-size-15
          "
          :class="{
            'active primary-color': bookGroupActive === index,
            'secondary-color-txt': bookGroupActive !== index,
          }"
          @click="handleFilterByGroup(index)"
        >
          {{ item }}
        </a>
      </div>
      <div
        v-else-if="selectBoxOpen === 'type'"
        class="filter-mobile__type display-flex-wrap justify-content-between"
      >
        <a
          v-for="(item, index) of bookTypes"
          :key="index"
          href="javascript:;"
          class="
            item
            btn btn-gray
            border-rd-20
            font-sanpro-semibold font-size-15
          "
          :class="{
            'active primary-color': bookTypeActive === index,
            'secondary-color-txt': bookTypeActive !== index,
          }"
          @click="handleFilterByType(index)"
        >
          {{ item }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { STORE_KEY } from "./../../_store/constants";

export default {
  name: "FilterMobile",
  props: {
    selectClass: Number,
    classes: Array,
    ebooks: Array,
    bookGroups: Array,
    bookTypes: Array,
  },
  data() {
    return {
      bookTypeActive: 0,
      selectBoxOpen: "", // class, group, type
    };
  },
  computed: {
    classId() {
      return parseInt(this.$route.query.classes);
    },
    classIndexActive() {
      let result = 0;
      if (this.$route.query.classes) {
        result = this.classes.findIndex(
          (cl) => cl.classId === parseInt(this.$route.query.classes)
        );
      }
      return result;
    },
    bookGroupActive() {
      return parseInt(this.$route.query.book_active) || 0;
    },
  },
  methods: {
    handleCollapseSelect(type) {
      this.selectBoxOpen = this.selectBoxOpen === type ? "" : type;
    },

    handleFilterByClass(data) {
      this.classId !== data.classId && this.$emit("filterClass", data.classId);
    },

    handleFilterByGroup(index) {
      if (this.bookGroupActive !== index) {
        // this.bookGroupActive = index
        this.bookTypeActive = 0;
        this.$router.replace({
          name: "ebook",
          query: { ...this.$route.query, book_active: index },
        });
        this.$emit("filterGroup", index);
      }
    },

    handleFilterByType(index) {
      if (this.bookTypeActive !== index) {
        this.bookTypeActive = index;
        this.$emit("filterType", index);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.w-auto {
  width: auto;
}

.filter-mobile {
  &__label {
    .item {
      width: 32%;
    }

    &.layout-2 {
      .item {
        width: 49%;
      }
    }
  }

  &__type {
    .item {
      width: calc(100% / 2.1);
      @extend .display-inline-block;

      &:not(:nth-child(2n + 2)) {
        margin-right: 10px;
      }
    }
  }

  @media screen and (min-width: 768px) {
    &__type {
      .item {
        width: calc(100% / 3.2);

        &:not(:nth-child(3n + 3)) {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
